<div class="wrapper" [class.active]="sidebar.sidebarVisible">
    <nav aria-label="Main navigation">
        <app-sidebar #sidebar></app-sidebar>
    </nav>
    <header>
        <app-client-info-bar></app-client-info-bar>
    </header>
    <main id="main-content">
        <!-- The skeleton is positioned over the outlet, not instead of it: Angular
             needs the outlet mounted to attach the resolved component, and the
             outlet is NOT empty during navigation — the outgoing page stays
             mounted until the new route activates, which is after the lazy chunk
             for it has downloaded. The skeleton has to cover that page, not stack
             beneath or above it in normal flow, or the two page-sized boxes
             double the document height for the duration of the navigation. -->
        @if (navigating()) {
        <app-page-skeleton [archetype]="archetype()" [listPanel]="listPanel()"></app-page-skeleton>
        }
        <router-outlet></router-outlet>
    </main>
</div>